export default {"src":"/_next/static/media/quark.c626eca1.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};